<template>
  <div>
    <FormSection>
      <SiteSelect :disabled="editMode" v-model="order.site_uuid" :companyUuid="order.company_uuid" required />
    </FormSection>

    <FormSection>
      <VehicleSelect
        v-model="order.vehicle_uuid"
        :companyUuid="order.company_uuid"
        :disabled="order.status != 'open'"
      />
    </FormSection>
    <InfoSection v-model="order" v-if="editMode" />
  </div>
</template>

<script>
import InfoSection from '@/components/Orders/forms/sections/InfoSection.vue'
import SiteSelect from '@/components/Orders/forms/sections/elements/SiteSelect.vue'
import VehicleSelect from '@/components/Orders/forms/sections/elements/VehicleSelect.vue'

export default {
  name: 'GatheringForm',
  components: {
    InfoSection,
    SiteSelect,
    VehicleSelect,
  },
  props: {
    value: { type: Object, required: true },
  },
  computed: {
    editMode() {
      return !!this.order.uuid
    },
    order: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>
